module.exports = __webpack_public_path__ + "static/physician_web_circle-4044b50d0f18f06e441533d3e8e69667.webp";